import React, { useState, useRef, useEffect } from "react";
import { Link,useLocation, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn.png";
import Normalbtn from "../assets/normal_btn.png";
import Badbtn from "../assets/bad_btn.png";

import SpinIcon from '../assets/spin_stress.gif';

import { Get, GetList, GetTime,GetHrv,UpdateKiosk } from '../lib/DeviceData';
import moment from 'moment';

import ttsAudio from "../assets/sound/tts_08.mp3"; // mp3 경로 import


const Readys = () => {
    const { t } = useTranslation();

    const location = useLocation();
    const userInfo = { ...location.state };
    const navigate = useNavigate();

    const audioRef = useRef(null);

    
    const [result_data, setDatas] = useState([]);

    const [hrv_data, setHrv] = useState([]);

    const [bucketTime, setbucketTime] = useState([]);
    const [HrTime, sethrTime] = useState([]);
    const [RrTime, setrrTime] = useState([]);
    const [ApneaTime, setapneaTime] = useState([]);
    const [MotionTime, setmotionTime] = useState([]);
    const [FsrTime, setfsrTime] = useState([]);

    const [device_sn, SetDevice_sn] = useState(0);
    const [device_no, SetDevice_no] = useState(0);
    const [member_no, SetMemeber_no] = useState(0);
    const [name, SetName] = useState('');
    const [sex, SetSex] = useState(0);
    const [birth, SetBirth] = useState(0);
    const [feel, SetFeel] = useState(0);
    const [closestHRVData, setClosestHRVData] = useState(null);
    const [dbok, setdbok] = useState(0);

    const [Kiosk, setKiosk] = useState({
          device_sn: "",          // string
            device_no: 0,           // number
            member_no: 0,           // number
            name: "",               // string
            sex: 0,               // number
            birth: "",              // string, ex: '19950409'
            feel: 0,                // number
            heart_avg: 0,           // number
            resp_avg: 0,            // number
            RMSSD: 0,               // number (대문자 주의)
            SDNN: 0,                // number
            pNN50: 0,               // number
            baevsky_si: 0,          // number
    });


    useEffect(() => {
        const data = userInfo;

        const device_sn=data.device_sn;
        const device_no=data.device_no;
        const member_no=data.device_no;
        const name=data.name;
        const sex=data.sex;
        const birth=data.birth;
        const feel = data.feel;

        const startTime = data.start;
        const endTime = data.end;


        if(device_no && endTime){
            GetTime(device_no,startTime,endTime, res => {
                setDatas(res);
            });

            GetHrv(device_no, res => {
                setHrv(res);
            });

        }
    }, []);

    useEffect(() => {
        if (result_data.rows){

            var array_bucket=[];
            var array_hr=[];
            var array_rr=[];
            var array_apnea=[];
            var array_motion=[];
            var array_fsr=[];

            result_data.rows.forEach(item => {
                array_bucket.push(moment(item.bucket).format('YYYY-MM-DD HH:mm:ss')); 
                array_hr.push(item.hr);
                array_rr.push(item.rr);
                array_fsr.push(item.fsr);
                if(item.motion!="-"){
                    array_motion.push(item.hr);
                }else{
                    array_motion.push('');
                }
                if(item.apnea!="-"){
                    array_apnea.push(item.rr);
                }else{
                    array_apnea.push('');
                }
            });

            setbucketTime(array_bucket[0]);
            sethrTime(array_hr[0]);
            setrrTime(array_rr[0]);


            const data = userInfo;

            SetDevice_sn(data.device_sn);
            SetDevice_no(data.device_no);
            SetMemeber_no(data.member_no);
            SetName(data.name);
            SetSex(data.sex);
            SetBirth(data.birth);
            SetFeel(data.feel);


        }     


    },[result_data.rows]);

    useEffect(() => {
        if (!hrv_data || hrv_data.length === 0) return;

        const targetHeartRate=hrv_data.rows[0].data.heart_rate;
        const new_hrv_data=hrv_data.rows[0].data.bcg_results;

        const closest = new_hrv_data.reduce((prev, curr) => {
        return Math.abs(curr.heart_rate - targetHeartRate) <
                Math.abs(prev.heart_rate - targetHeartRate)
            ? curr
            : prev;
        });


        setClosestHRVData(closest.hrv_analysis_data);
    }, [hrv_data]);

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    const clickResult= () => {
        const rmssd=Number(closestHRVData.rmssd);
        const pnn50=Number(closestHRVData.pnn50);
        const sdnn=Number(closestHRVData.sdnn)+20;
        const baevsky_si=Number(closestHRVData.baevsky_si);

        Kiosk.device_sn=device_sn;
        Kiosk.device_no=Number(device_no);
        Kiosk.member_no=Number(member_no);
        Kiosk.name=name;
        Kiosk.sex=Number(sex);
        Kiosk.birth=birth;
        Kiosk.feel=Number(feel);
        Kiosk.heart_avg=Number(HrTime);
        Kiosk.resp_avg=Number(RrTime);
        Kiosk.rmssd=Number(rmssd);
        Kiosk.sdnn=Number(sdnn);
        Kiosk.pnn50=Number(pnn50);
        Kiosk.baevsky_si=Number(baevsky_si);
        Kiosk.date=moment().format('YYYY-MM-DD HH:mm:ss');
        
        setKiosk(Kiosk);

        UpdateKiosk(Kiosk, res => {
             setdbok(res);
        });


        navigate('/result', {
            state: {
                device_sn: `${device_sn}`,
                device_no: `${device_no}`,
                member_no: `${member_no}`,
                name: `${name}`,
                sex: `${sex}`,
                birth: `${birth}`,
                feel: `${feel}`,
                date: `${bucketTime}`,
                hr : `${HrTime}`,
                rr : `${RrTime}`,
                sdnn : `${sdnn}`,
                rmssd : `${rmssd}`,
                pnn50 : `${pnn50}`,
                baevsky_si : `${baevsky_si}`
            },
        });
    }



    return (
        <main className="main-container">

            <audio ref={audioRef} src={ttsAudio} autoPlay />

            <div className="Top_loading">
                <h2>측정이 완료되었습니다.<br />아래버튼을 눌러<br />결과를 확인해보세요.</h2>
                <div className="start-btn-area">
                    <button className="Start" onClick={() => clickResult()}>결과보기</button>
                </div>
            </div>
        </main>
    );
};

export default Readys;
